<template>
    <Loader v-if="loader"/>
    <div class="login-container">
        <div class="left">
            <CRow class="mb-1 align-items-center">
                <img
                    alt="Coherent logo"
                    class="sidebar-brand-full logo col-12"
                    src="/images/coherent-full.svg"/>
            </CRow>
            <form @submit.prevent="handleLogin()">
                <div class="form-group" v-if="!support">
                    <i class="fa fa-envelope-o icon"></i>
                    <input type="text" placeholder="Enter your email" v-model="email"/>
                    <CCol v-if="error?.response?.data?.details?.email">
                        <small class="text-danger">{{ error.response.data.details.email[0].message }}</small>
                    </CCol>
                </div>
                <div class="form-group" v-if="!support">
                    <i class="fa fa-eye-slash icon password-eye clickable" @click="togglePasswordVisibility"></i>
                    <input :type="passwordVisible ? 'text' : 'password'" placeholder="Enter your password"
                           v-model="password"
                           class="password-input"/>
                    <CCol v-if="error?.response?.data?.details?.password">
                        <small class="text-danger">{{ error.response.data.details.password[0].message }}</small>
                    </CCol>
                </div>
                <div v-if="support">
                    <p class="py-5">Please email support@coherenthealthcare.com
                    </p>
                </div>
                <div class="form-group recover-password">
                    <a @click="toggleSupport" v-if="!support">Recover password</a>
                    <a @click="toggleSupport" v-else>Go back</a>
                </div>
                <input class="clickable" type="submit" value="Sign in" :disabled="support"/>
                <CCol v-if="error" class="mt-2 text-center">
                    <small class="text-danger" v-if="error?.response?.data?.message">
                        {{ error.response.data.message }}
                    </small>
                    <small class="text-danger" v-else>An error occurred</small>
                </CCol>
                    <p v-if="true" class="cookie-message"> By signing in, you agree to our use of cookies as detailed on <a href="https://coherenthealthcare.com" target="_blank">our website</a>.</p>

                   
            </form>
        </div>
        <div class="right"/>
    </div>
</template>

<script>
import {ref} from 'vue';
import {useRouter} from "vue-router";
import axios from "axios";
import {SERVICE_URL} from "@/serviceResolver";

export default {
    name: 'Login',
    data() {
        return {
            loader: false,
            error: null,
            support: false,
            email: "",
            password: ""
        };
    },
    setup() {

        const router = useRouter();
        const passwordVisible = ref(false);
        const togglePasswordVisibility = () => {
            passwordVisible.value = !passwordVisible.value;
        };

        return {
            togglePasswordVisibility,
            passwordVisible,
            router,
        };
    },
    methods: {
        async handleLogin() {
            this.loader = true;
            this.error = null;
            try {
                const response = await axios.post(`${SERVICE_URL}/user/auth/sign-in`, {
                    email: this.email,
                    password: this.password
                });

                localStorage.setItem('authToken', response.data.apiToken);
                const user = response.data.user
                axios.defaults.headers.common['access-token'] = response.data.apiToken;

                if (user.merchant.uuid === "163a70f5-a8ac-4c5c-8d27-f86fe509d85d") {
                    this.router.push({ name: 'Lists' })
                }
                else{
                    if(user.merchant.onboarded){
                        this.router.push({name: 'Home'});
                    }
                    else{
                    this.router.push({name: 'Onboarding'});
                    }
                }
            } catch (error) {
                this.error = error;
                console.error("Error:", error);
            }
            this.loader = false
        },
        toggleSupport() {
            this.support = !this.support
        }
    }
};
</script>

<style scoped>

.login-container {
    height: 100%;
    width: 100%;
    position: absolute;
    display: block;
}

@media (max-width: 600px) {
    .left {
        width: 100%;
    }

    .right {
        display: none;
    }
}

@media (min-width: 600px) {
    .left {
        width: 50%
    }

    .right {
        width: 50%;
        display: block;
    }
}

.left {
    padding: 40px 10%;
    float: left;
    box-sizing: border-box;
    height: 100%;
    display: flex;
    position: absolute;
    flex-direction: column;
    justify-content: center;
}

.right {
    height: 100%;
    float: right;
    position: absolute;
    right: 0;
    background-image: url('@/assets/images/bg.jpeg');
    background-size: cover;
    background-position: center;
}


h1 {
    font-family: Inter;
    font-size: 42px;
    font-weight: 400;
    line-height: 51px;
    letter-spacing: 1px;
    text-align: left;
    margin-top: 60px;
}

.form {
    margin-top: -4px;
    position: relative;
}

label {
    font-family: Inter;
    font-size: 14px;
    font-weight: 700;
    line-height: 21px;
    letter-spacing: 0px;
    text-align: left;
    color: #000;
    margin-bottom: -5px;
}

input[type="text"],
input[type="password"] {
    width: 100%;
    height: 64px;
    border: solid 1px #dee6e2;
    font-family: Inter;
    font-size: 14px;
    font-weight: 400;
    line-height: 21px;
    letter-spacing: 0px;
    text-align: left;
    border-radius: 10px;
    margin: 18px 0;
    padding: 0 20px;
    box-sizing: border-box;
}

input[type="submit"] {
    background-color: #0052FF;
    width: 100%;
    color: #fff;
    height: 52px;
    line-height: 52px;
    border: none;
    border-radius: 10px;
    margin-top: 30px;
    font-family: Inter;
    font-size: 14px;
    font-weight: 700;
    letter-spacing: 0px;
    text-align: center;
}

input[type="submit"]:disabled {
    background-color: rgba(81, 95, 124, 0.25);
}

#email::after {
    content: 'Q';
    position: absolute;
    top: 50%;
    right: 10px;
    transform: translateY(-50%);
}

.form-group {
    position: relative;
}

.form-group i {
    position: absolute;
    right: 0;
    top: 32px;
    text-align: center;
}

.icon {
    padding: 10px;
    min-width: 40px;
}

.recover-password {
    font-family: Inter;
    font-size: 12px;
    font-weight: 700;
    line-height: 18px;
    letter-spacing: 0px;
    text-align: right;
}

.recover-password a {
    color: #000;
    text-decoration: none;
}

.clickable {
    cursor: pointer;
}
.cookie-message {
  font-size: 9pt;
  color: #6c757d;
  margin-top: 10px;
  text-align: center;
}

.cookie-message a {
  color: #007bff; 
  text-decoration: none;
}

.cookie-message a:hover {
  text-decoration: underline;
}

</style>
